<template>
  <div class="LmActorLabel">
    <span v-if="hasSlot" class="Text">
      <slot></slot>
    </span>
    <span class="Label" :class="actor.color">{{ actor.name }}</span>
  </div>
</template>

<script>
export default {
  name: 'LmActorLabel',
  props: {
    actor: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasSlot() {
      return !!this.$slots.default
    }
  }
}
</script>

<style scoped>
.LmActorLabel {
  line-height: 1.4;
  font-size: 15px;
  color: #757575;
  .Text {
    margin-right: 6px;
  }
  .Label {
    font-size: 15px;
    text-transform: capitalize;
  }
}
</style>
